import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useState } from 'react';
import isValid from 'date-fns/isValid';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';
import parseISO from 'date-fns/parseISO';
import isEqual from 'lodash/isEqual';
import AkCalendar from '@atlaskit/calendar';
var getDateObj = function getDateObj(date) {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
};
var getValidDate = function getValidDate(iso) {
  if (!iso) {
    return {};
  }
  var date = parseISO(iso);
  return isValid(date) ? getDateObj(date) : {};
};
export var padToTwo = function padToTwo(num) {
  return num <= 99 ? "0".concat(num).slice(-2) : "".concat(num);
};
export var DayPicker = /*#__PURE__*/memo(function (props) {
  var currentDate = props.date;
  var _useState = useState(currentDate),
    _useState2 = _slicedToArray(_useState, 2),
    viewDate = _useState2[0],
    setViewDate = _useState2[1];
  var _onSelect = useCallback(function (iso) {
    setViewDate(iso);
    var newDateObj = {
      start: iso,
      end: iso
    };
    props.onSelect(newDateObj);
  }, [props]);
  var _onChange = useCallback(function (iso) {
    if (!iso) {
      return;
    }
    var _iso$split = iso.split('-'),
      _iso$split2 = _slicedToArray(_iso$split, 3),
      year = _iso$split2[0],
      month = _iso$split2[1],
      date = _iso$split2[2];
    var newIso = iso;
    var parsedDate = parseInt(date, 10);
    var parsedMonth = parseInt(month, 10);
    var parsedYear = parseInt(year, 10);
    var lastDayInMonth = lastDayOfMonth(new Date(parsedYear, parsedMonth - 1) // This needs to be -1, because the Date constructor expects an index of the given month
    ).getDate();
    if (lastDayInMonth < parsedDate) {
      newIso = "".concat(year, "-").concat(padToTwo(parsedMonth), "-").concat(padToTwo(lastDayInMonth));
    } else {
      newIso = "".concat(year, "-").concat(padToTwo(parsedMonth), "-").concat(padToTwo(parsedDate));
    }
    setViewDate(newIso);
  }, []);
  return /*#__PURE__*/React.createElement(AkCalendar, _extends({}, getValidDate(viewDate), {
    selected: [currentDate || ''],
    onChange: function onChange(e) {
      return _onChange(e.iso);
    },
    onSelect: function onSelect(e) {
      return _onSelect(e.iso);
    }
  }));
}, function (prevProps, nextProps) {
  return isEqual(prevProps.date, nextProps.date);
});